import { Timer } from '#x1-base/utils';

export function useTimer(fn?: Function, interval = 1000): Timer {
    return new Timer(fn, interval);
}
